import styled, { withTheme } from "styled-components";
import { Button } from "antd";
import { Metrics } from "../../theme";

const buttonStyle = (props, context)=>`
    background-color:${props.type === "secondary" ? 
		props.theme.subColor : 
		props.theme.mainColor};
    color:${props.theme.button.textColor};
    border-width: 0px;
    border-radius: ${Metrics.borderRadius}px;
    ${props.height ? `height: ${props.height}px;` : ""}
    ${props.minWidth ? `min-width: ${props.minWidth}px;` : ""}
`;

export const OButton = withTheme(styled(Button)`
    ${(props)=>buttonStyle(props)}
    &:hover {${(props)=>buttonStyle(props)}}
    &:focus {${(props)=>buttonStyle(props)}}
`);


// WEBPACK FOOTER //
// ./src/components/button/OButton.js